<template>
  <div v-if="totalPages > 0" class="pagination-container">
    <ul class="pagination">
      <li class="page-previous">
        <a
          v-if="currentPageNumber > 1"
          @click.prevent="$emit('setPage', currentPageNumber - 1)"
        >
          <span class="icon">Previous page</span>
        </a>
      </li>
      <template
        v-for="(deviceSize, deviceSizeIndex) in [
          { cls: 'hide-for-medium-up', windowSize: 0 },
          { cls: 'show-for-medium-up', windowSize: 2 },
        ]"
      >
        <li
          v-for="pageNumber in pageNumbersToShow(deviceSize.windowSize)"
          :key="`${deviceSizeIndex}_${pageNumber}`"
          :class="{
            current: pageNumber === currentPageNumber,
            ellipsis: pageNumber === '...',
            [deviceSize.cls]: true,
          }"
        >
          <template v-if="pageNumber === currentPageNumber">
            <span class="show-for-sr">You're on page</span>
            <span class="current-page">{{ pageNumber }}</span>
          </template>
          <a
            v-else-if="pageNumber !== '...'"
            @click.prevent="$emit('setPage', pageNumber)"
            >{{ pageNumber }}</a
          >
        </li>
      </template>
      <li class="page-next">
        <a
          v-if="currentPageNumber < totalPages"
          @click.prevent="$emit('setPage', currentPageNumber + 1)"
        >
          <span class="icon">Next page</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export const genPagesToShowArray = (windowSize, totalPages, currentPageNum) => {
  /*
   -includes page numbers surrounding current page
   -always includes first and last page
   -adds ellipses
  */
  const rightWindowEnd = currentPageNum + windowSize
  const leftWindowStart = currentPageNum - windowSize
  return Array.from(Array(totalPages).keys())
    .map((n) => n + 1)
    .reduce((acc, n) => {
      if (
        // always show first, last, and current page number
        n === 1 ||
        n === totalPages ||
        n === currentPageNum ||
        // show current and a few pages after current one
        (n <= rightWindowEnd && n > currentPageNum - 1) ||
        // show current and a few pages before current one
        (n >= leftWindowStart && n < currentPageNum + 1) ||
        // if outside previous conditions and less than 2 extra pages in segment,
        //   just show it
        (n < currentPageNum && leftWindowStart - 1 < 3) ||
        (n > currentPageNum && totalPages - rightWindowEnd < 3)
      ) {
        acc.push(n)
      } else if (
        // ellipsis cases - at least 2 available to collapse
        (n === 2 && leftWindowStart - 1 > 2) ||
        (n === totalPages - 1 && totalPages - rightWindowEnd > 2)
      ) {
        acc.push('...')
      }
      return acc
    }, [])
}

export default {
  name: 'PaginationControls',
  props: {
    currentPageNumber: {
      type: Number,
      default: 0,
    },
    totalPages: {
      type: Number,
      default: 0,
    },
  },
  emits: ['setPage'],
  methods: {
    pageNumbersToShow(windowSize) {
      return genPagesToShowArray(
        windowSize,
        this.totalPages,
        this.currentPageNumber,
      )
    },
  },
}
</script>
